export enum EntityType {
  CASE = "CA",
  AR = "AR",
  CREDITOR = "CR",
  CREDITOR_GROUP = "CG",
  BUREAU = "BU",
}

export const DEFAULT_GROUP = "All"